<template>
    <div>

        <div class="set-language">
            <div class="set-language-content">


                <div class="current-lang">
                    <small>
                        Текущий:
                        <span v-if="language==='ru'"><b>Русc</b></span>
                        <span v-else-if="language==='uz'"><b>O'zb</b></span>
                    </small>
                </div>
                <div>

                    <button :disabled="load" @click="setLanguage('ru')">
                        <v-img :class="`languages ${(language==='ru') ? 'active' : '' } pointer`"
                               width="33"
                               src="/img/languages/russia.png"/>

                    </button>

                    <button :disabled="load" @click="setLanguage('uz')">
                        <v-img :class="`languages ${(language==='uz') ? 'active' : '' } pointer`"
                               width="33"

                               src="/img/languages/uzbekistan.png"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapMutations} from 'vuex';
    import Loader from "../helper/Loader";


    export default {
        components: {Loader},
        data: () => ({
            load: false
        }),
        methods: {
            ...mapMutations(['SET_LANGUAGE']),
            setLanguage(lang) {

                this.load = true;

                this.$dialog
                    .confirm('Вы точно хотите поменять на язык ' + lang + '? Внимание! ' +
                        'Если вы что-то меняли для контента на другом языке - сохраните.', {
                        okText: 'Установить язык: ' + lang,
                        cancelText: 'Отмена'
                    })
                    .then(() => {
                        this.SET_LANGUAGE(lang);
                        this.load = false;
                    })
                    .catch(() => {
                        this.load = false;
                    });
            }
        },
        computed: {
            ...mapState(['language','role','menu'])
        }
    }
</script>

<style lang="scss">
    .set-language {
        overflow: hidden;
       
        z-index: 99999;

        &-content {
            position: relative;
        }

        @media(max-width:768px){
            display: none
        }
    }

    .current-lang {
        padding-left: 20px;
        color: #444;

        small {
            font-size: 8px;
        }
    }
</style>
